module.exports = __webpack_public_path__ + "assets/img/img223.7c7012a0.png";